import script from "./ds-input.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20DsFormFieldValueType"
export * from "./ds-input.vue?vue&type=script&setup=true&lang=ts&generic=T%20extends%20DsFormFieldValueType"

const __exports__ = script;

export default __exports__